import { render, staticRenderFns } from "./DepartWindow.vue?vue&type=template&id=2c48713b&scoped=true"
import script from "./DepartWindow.vue?vue&type=script&lang=js"
export * from "./DepartWindow.vue?vue&type=script&lang=js"
import style0 from "./DepartWindow.vue?vue&type=style&index=0&id=2c48713b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c48713b",
  null
  
)

export default component.exports